import { useTranslation } from 'react-i18next';

import { Button, NextImage, Typography } from '@/shared/components/atoms';
import { roles } from '@/shared/constant/roles-and-permissions';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

import AppAR from '~/images/Ecosystem/AppInvitationAR.png';
import AppES from '~/images/Ecosystem/AppInvitationEN.png';
import AppFR from '~/images/Ecosystem/AppInvitationEN.png';
import AppEN from '~/images/Ecosystem/AppInvitationEN.png';
import AppKA from '~/images/Ecosystem/AppInvitationEN.png';
import CheckMarkWithoutBG from '~/images/shared/CheckMarkWithoutBG.svg';
import GreenLeaf from '~/images/shared/GreenLeaf.svg';

const AddTeamMemeberSuccessModal: React.FC<{
  role: number;
  addAnotherFunction: () => void;
}> = ({ role, addAnotherFunction }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation('common');
  const { closeModal } = useModal();
  const isAppUser =
    role === roles.SUPERVISOR ||
    role === roles.PRODUCTION_MANAGER ||
    role === roles.ONBOARDING_SUPERVISOR ||
    role === roles.ONBOARDING ||
    role === roles.FACTORY_SUPERVISOR ||
    role === roles.COMPANY_ADMIN;

  return (
    <div className='flex flex-col items-center justify-center gap-16 px-2 text-center'>
      <div className='flex h-64 w-64 items-center justify-center rounded-full bg-secondary-90 text-green-300'>
        <CheckMarkWithoutBG width='30' height='30' />
      </div>
      {isAppUser ? (
        <>
          <Typography
            weight='semiBold'
            variant='h6'
            className='mx-auto max-w-sm whitespace-normal text-center'
          >
            {t('app-invitation-sent')}
            <GreenLeaf className='align-text-center inline ltr:ml-1 rtl:mr-1' />
          </Typography>
          <Typography
            className='flex flex-col gap-24 text-surface-10'
            variant='caption'
          >
            <span> {t('app-invitation-sent-description-p1')}</span>
            <span> {t('app-invitation-sent-description-p2')}</span>
          </Typography>
          <NextImage
            alt={t('field-app')}
            src={
              language === 'ar'
                ? AppAR
                : language === 'es'
                ? AppES
                : language === 'fr'
                ? AppFR
                : language === 'ka'
                ? AppKA
                : AppEN
            }
            height={230}
            width={270}
            className='w-fit'
          />
        </>
      ) : (
        <>
          <div>
            <Typography weight='semiBold' variant='h6'>
              {t('congratulations')}
            </Typography>
            <Typography weight='semiBold' variant='h6'>
              {t('you-invited-member')}
            </Typography>
          </div>
          <Typography className='text-surface-10' variant='caption'>
            <span>{t('you-invited-member-description')} </span>
            <span className='font-bold'>
              {t('settings', {
                ns: 'navigation',
              })}{' '}
              &gt;{' '}
              {t('team', {
                ns: 'navigation',
              })}
              .
            </span>
          </Typography>
        </>
      )}
      <div className='flex w-full items-center justify-end gap-1'>
        <Button
          size='sm'
          onClick={() => {
            closeModal();
            closeModal();
          }}
          variant='text'
        >
          {t('done')}
        </Button>
        <Button size='sm' onClick={addAnotherFunction}>
          {t('invite-another-member')}
        </Button>
      </div>
    </div>
  );
};
export { AddTeamMemeberSuccessModal };
